###
@author Justinas Jurciukonis (justinas.jurciukonis@visma.com)
@company Visma Lietuva
###

angular
	.module 'App.Directive'
	.directive 'wmIncludeReplace', ->
		require: 'ngInclude'
		restrict: 'A'
		link: (scope, el, attrs) ->
			el.replaceWith(el.children())
